<template>
  <v-container class="sasv-status text-center"
               v-if="sasv">
    <v-row>
      <v-col class="title-font font-size-70">
        <v-icon :style="titleIconStyle" size="3.75rem">{{ titleIcon }}</v-icon>
        {{ title }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="title-font  font-size-45">
        {{ descriptions }}
      </v-col>
    </v-row>
    <v-row class="sasv-status-details pa-8">
      <v-col cols="12" md="6">
        <v-text-field readonly
                      :label="$t('check_status.octopus_no')"
                      :value="sasv.octopus_no"
                      hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field readonly
                      :label="$t('check_status.name')"
                      :value="sasv.name"
                      hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field readonly
                      :label="$t('check_status.status')"
                      :value="title"
                      hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="6"
             v-if="sasv.status === 'APPROVED' && sasv.validated_at">
        <v-text-field readonly
                      :label="$t('check_status.validated_at')"
                      :value="$parseDate(sasv.validated_at)"
                      hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="6"
             v-if="sasv.rejected_at">
        <v-text-field readonly
                      :label="$t('check_status.rejected_at')"
                      :value="$parseDate(sasv.rejected_at)"
                      hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="6"
             v-if="sasv.status === 'SUSPENDED' && sasv.suspended_at">
        <v-text-field readonly
                      :label="$t('check_status.suspended_at')"
                      :value="$parseDate(sasv.suspended_at)"
                      hide-details></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed} from "@vue/composition-api";

export default {
  name: 'SasvStatus',
  props: {
    sasv: Object,
  },
  setup(props, {root}) {
    const titleIcon = computed(() => {
      if (!props.sasv) return '';

      return {
        PENDING_APPROVAL: 'mdi-dots-horizontal-circle-outline',
        APPROVED: 'mdi-check-circle-outline',
        REJECTED: 'mdi-close-circle-outline',
        SUSPENDED: 'mdi-cancel',
      }[props.sasv.status];
    });

    const title = computed(() => {
      if (!props.sasv) return '';

      return {
        PENDING_APPROVAL: root.$t('check_status.pending'),
        APPROVED: root.$t('check_status.approved'),
        REJECTED: root.$t('check_status.rejected'),
        SUSPENDED: root.$t('check_status.suspended'),
      }[props.sasv.status];
    })

    const titleIconStyle = computed(() => {
      if (!props.sasv) return {};

      return {
        PENDING_APPROVAL: {},
        APPROVED: {color: '#91c050'},
        REJECTED: {color: '#e15c5b'},
        SUSPENDED: {color: '#e15c5b'},
      }[props.sasv.status];
    });

    const descriptions = computed(() => {
      if (!props.sasv) return '';

      return {
        PENDING_APPROVAL: root.$t('check_status.pending_msg'),
        APPROVED: root.$t('check_status.approved_msg'),
        REJECTED: root.$t('check_status.rejected_msg'),
        SUSPENDED: root.$t('check_status.suspended_msg'),
      }[props.sasv.status];
    })

    return {
      titleIcon,
      title,
      titleIconStyle,
      descriptions,
    }
  },
}
</script>

<style lang="less">
.sasv-status {
  .sasv-status-details {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    background-color: #f7f7f7;
  }
}
</style>
